import { getStainingMethodByStainType, StainingMethod } from 'interfaces/stainType';
import { isEmpty, isEqual } from 'lodash';

const getMarkersForStain = (stain: string) => {
  if (isEmpty(stain)) {
    return [];
  }

  return getStainingMethodByStainType(stain) === StainingMethod.mplex ? [] : [stain];
};

export const changeStainTypeAndMarkers = (
  stain: string,
  currentSelectedStainType: string,
  currentMarkers: string[],
  setSelectedStainType: (stain: string) => void,
  setMarkers: (markers: string[]) => void
) => {
  const nextStainType = stain || '';
  const nextMarkers = getMarkersForStain(stain);

  if (currentSelectedStainType !== nextStainType) {
    setSelectedStainType(nextStainType);

    if (!isEqual(currentMarkers, nextMarkers)) {
      setMarkers(nextMarkers);
    }
  }
};
